import { WALKTHROUGHS_ENABLED } from '@/components/walkthrough/walkthrough-availability';

export type FloatingActionPillPlacement = 'floating' | 'thread-sidebar';

type FloatingActionPillStateArgs = {
  placement: FloatingActionPillPlacement;
  hasWalkthroughForRoute: boolean;
  isWalkthroughActive: boolean;
  isFeedbackRoute: boolean;
  hasWorkspace: boolean;
};

type FloatingActionPillState = {
  helpAction: 'tour' | 'support' | null;
  showFeedback: boolean;
};

export function getFloatingActionPillState({
  placement,
  hasWalkthroughForRoute,
  isWalkthroughActive,
  isFeedbackRoute,
  hasWorkspace,
}: FloatingActionPillStateArgs): FloatingActionPillState {
  const canStartTour =
    WALKTHROUGHS_ENABLED && hasWalkthroughForRoute && !isWalkthroughActive;

  if (placement === 'thread-sidebar') {
    return {
      helpAction: canStartTour ? 'tour' : hasWorkspace ? 'support' : null,
      showFeedback: true,
    };
  }

  return {
    helpAction: canStartTour ? 'tour' : null,
    showFeedback: isFeedbackRoute,
  };
}
